// replace Record<string, any> with ParcelModel
const GetVolumeWeight = (row: Record<string, any>): number => {
    let VolumeWeight = 0
    const l = row?.dimension_length
    const w = row?.dimension_width
    const h = row?.dimension_height
    if (h && w && l) VolumeWeight = ((l * 2.54 * (w * 2.54) * (h * 2.54)) / 5000) * 2.2

    return VolumeWeight
}

export default GetVolumeWeight
